import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '../../../../icon/icon/icon.component';

@Component({
  selector: 'osp-card-option',
  standalone: true,
  imports: [IconComponent, NgClass],
  templateUrl: './card-option.component.html',
  styleUrl: './card-option.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardOptionComponent {
  @Input() type!: string;
  @Input() label!: string;
  @Input() icon!: string;
  @Input() description?: string;
  @Input() selected: boolean = false;
  @Input() selectable: boolean = false;
}
